var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWhiteVertical = function SvgWhiteVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 205 477",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__a)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.514.484H.534v68.032h67.98V.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.495 0c0 19.018-15.198 34.437-33.99 34.437S.593 19.057.593 0M68.864 34.476H0M14.024 56.995c2.976 0 5.39-2.403 5.39-5.368 0-2.965-2.414-5.369-5.39-5.369-2.977 0-5.39 2.404-5.39 5.369s2.413 5.368 5.39 5.368ZM34.437 56.995c2.977 0 5.39-2.403 5.39-5.368 0-2.965-2.413-5.369-5.39-5.369s-5.39 2.404-5.39 5.369 2.413 5.368 5.39 5.368ZM54.841 56.995c2.977 0 5.39-2.403 5.39-5.368 0-2.965-2.413-5.369-5.39-5.369s-5.39 2.404-5.39 5.369 2.413 5.368 5.39 5.368Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__b)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.484 68.541v67.976h68.021V68.541H.485Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.484 102.524c4.473.005 8.9.889 13.03 2.6a34.048 34.048 0 0 1 11.039 7.373 33.947 33.947 0 0 1 7.368 11.024 33.853 33.853 0 0 1 2.574 12.996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.505 68.541a33.853 33.853 0 0 1-2.578 12.995 33.938 33.938 0 0 1-7.371 11.022 34.057 34.057 0 0 1-11.042 7.37 34.15 34.15 0 0 1-13.03 2.596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.457 136.517V68.483H.485v68.034h67.972Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.457 102.495a34.149 34.149 0 0 1-13.025-2.61 34.055 34.055 0 0 1-11.032-7.38 33.938 33.938 0 0 1-7.358-11.027 33.851 33.851 0 0 1-2.566-12.995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.466 136.517a33.864 33.864 0 0 1 2.566-12.999 33.942 33.942 0 0 1 7.362-11.03 34.059 34.059 0 0 1 11.034-7.382 34.144 34.144 0 0 1 13.029-2.611"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__c)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.514 340.484h-67.98v68.032h67.98v-68.032Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.495 340c0 19.018-15.198 34.437-33.99 34.437-18.791 0-33.912-15.381-33.912-34.437M136.864 374.476H68M82.024 396.995c2.976 0 5.39-2.403 5.39-5.368 0-2.965-2.414-5.369-5.39-5.369-2.977 0-5.39 2.404-5.39 5.369s2.413 5.368 5.39 5.368ZM102.437 396.995c2.976 0 5.39-2.403 5.39-5.368 0-2.965-2.414-5.369-5.39-5.369-2.977 0-5.39 2.404-5.39 5.369s2.413 5.368 5.39 5.368ZM122.841 396.995c2.977 0 5.39-2.403 5.39-5.368 0-2.965-2.413-5.369-5.39-5.369s-5.39 2.404-5.39 5.369 2.413 5.368 5.39 5.368Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__d)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.484 408.541v67.976h68.021v-67.976h-68.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.484 442.524c4.473.005 8.9.889 13.03 2.6a34.048 34.048 0 0 1 11.039 7.373 33.947 33.947 0 0 1 7.368 11.024 33.866 33.866 0 0 1 2.574 12.996M102.504 408.541a33.827 33.827 0 0 1-2.577 12.995 33.94 33.94 0 0 1-7.371 11.022 34.052 34.052 0 0 1-11.041 7.37 34.144 34.144 0 0 1-13.03 2.596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.457 476.517v-68.034H68.485v68.034h67.972Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.457 442.495a34.148 34.148 0 0 1-13.025-2.61 34.063 34.063 0 0 1-11.032-7.38 33.921 33.921 0 0 1-7.358-11.027 33.846 33.846 0 0 1-2.566-12.995M102.466 476.517a33.87 33.87 0 0 1 2.566-12.999 33.958 33.958 0 0 1 7.361-11.03 34.065 34.065 0 0 1 11.035-7.382 34.146 34.146 0 0 1 13.029-2.611"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__e)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.514 136.483H.486v68.033h68.028v-68.033Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.514 168.213c0 19.873-15.227 35.984-34.033 35.984S.486 188.086.486 168.213M68.426 170.514H.544M.428 136.338l34.101 33.964M68.611 136.338 34.52 170.292M38.237 156.635a5.298 5.298 0 0 0-.365-7.513 5.37 5.37 0 0 0-7.555.364 5.298 5.298 0 0 0 .366 7.513 5.37 5.37 0 0 0 7.554-.364Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__f)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.446 306.485h-16.33M16.943 306.485H.849M15.747 308.919a21.407 21.407 0 0 0-.307 19.915 21.282 21.282 0 0 0 6.68 7.757 21.158 21.158 0 0 0 9.513 3.724c.728.103 1.46.166 2.195.188H.494v-68.006H34.6l-17.586 33.978-1.266 2.444ZM68.505 272.497v67.996H35.291a19.367 19.367 0 0 0 2.165-.178 21.188 21.188 0 0 0 9.584-3.81 21.315 21.315 0 0 0 6.672-7.895 21.438 21.438 0 0 0-.618-20.088l-.05-.109-.988-1.938L34.6 272.497h33.907Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.864 340.245h-3.242v.507h3.242v-.507Z",
    fill: "#fff",
    strokeWidth: 0.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__g)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.77 363.354c2.809 0 2.809 5.905 5.608 5.905 2.8 0 2.81-5.905 5.619-5.905 2.81 0 2.8 5.905 5.599 5.905 2.8 0 2.809-5.905 5.618-5.905 2.81 0 2.8 5.905 5.609 5.905 2.81 0 2.81-5.905 5.609-5.905 2.8 0 2.809 5.905 5.618 5.905 2.81 0 2.8-5.905 5.609-5.905 2.81 0 2.81 5.905 5.609 5.905 2.8 0 2.809-5.905 5.618-5.905 2.81 0 2.81 5.905 5.619 5.905 2.81 0 2.81-5.905 5.618-5.905M.77 353.975c2.809 0 2.809 5.905 5.608 5.905 2.8 0 2.81-5.905 5.619-5.905 2.81 0 2.8 5.905 5.599 5.905 2.8 0 2.809-5.905 5.618-5.905 2.81 0 2.8 5.905 5.609 5.905 2.81 0 2.81-5.905 5.609-5.905 2.8 0 2.809 5.905 5.618 5.905 2.81 0 2.8-5.905 5.609-5.905 2.81 0 2.81 5.905 5.609 5.905 2.8 0 2.809-5.905 5.618-5.905 2.81 0 2.81 5.905 5.619 5.905 2.81 0 2.81-5.905 5.618-5.905M.77 345.571c2.799 0 2.799 5.905 5.608 5.905 2.81 0 2.81-5.905 5.609-5.905 2.8 0 2.81 5.905 5.609 5.905 2.8 0 2.809-5.905 5.608-5.905 2.8 0 2.81 5.905 5.61 5.905 2.799 0 2.808-5.905 5.618-5.905 2.809 0 2.8 5.905 5.608 5.905 2.81 0 2.81-5.905 5.619-5.905 2.81 0 2.8 5.905 5.609 5.905s2.809-5.905 5.618-5.905c2.81 0 2.81 5.905 5.619 5.905 2.81 0 2.81-5.905 5.618-5.905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.507 340.492H.493v68.016h68.014v-68.016Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.498 374.544c0 18.286-15.21 33.108-33.978 33.108S.553 392.83.553 374.544M.661 374.505h67.63"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__h)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.507 408.493H.493v68.014h68.014v-68.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.291 442.5a33.677 33.677 0 0 1-20.96 31.02 33.678 33.678 0 0 1-12.91 2.494 33.678 33.678 0 0 1-31.238-20.633A33.678 33.678 0 0 1 .553 442.5M.553 442.461H68.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.563 442.5a33.67 33.67 0 0 1 20.952-31.02 33.671 33.671 0 0 1 12.907-2.494 33.678 33.678 0 0 1 31.24 20.633A33.676 33.676 0 0 1 68.29 442.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.486 442.5a27.935 27.935 0 0 1 55.87 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.42 442.5a22 22 0 0 1 44.002 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.355 442.5a16.076 16.076 0 0 1 32.144 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.288 442.5a10.143 10.143 0 0 1 20.276 0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__i)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.493 204.5v67.98h68.015V204.5H.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.188 204.706c20.218 0 36.593 15.172 36.593 33.902S20.406 272.51.188 272.51M.818 238.48h36.348M37.747 272.049V204.99M44.26 204.99v67.059M50.763 204.99v67.049M57.275 204.99v67.049M63.778 204.99v67.049"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__j)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.514.484h-67.98v68.032h67.98V.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.495 0c0 19.018-15.198 34.437-33.99 34.437-18.791 0-33.912-15.38-33.912-34.437M204.864 34.476H136M150.024 56.995c2.976 0 5.39-2.403 5.39-5.368 0-2.965-2.414-5.369-5.39-5.369-2.977 0-5.39 2.404-5.39 5.369s2.413 5.368 5.39 5.368ZM170.437 56.995c2.976 0 5.39-2.403 5.39-5.368 0-2.965-2.414-5.369-5.39-5.369-2.977 0-5.39 2.404-5.39 5.369s2.413 5.368 5.39 5.368ZM190.841 56.995c2.977 0 5.39-2.403 5.39-5.368 0-2.965-2.413-5.369-5.39-5.369s-5.39 2.404-5.39 5.369 2.413 5.368 5.39 5.368Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__k)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.484 68.541v67.976h68.021V68.541h-68.021Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.484 102.524c4.473.005 8.9.889 13.03 2.6a34.051 34.051 0 0 1 11.039 7.373 33.873 33.873 0 0 1 9.942 24.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.504 68.541a33.836 33.836 0 0 1-2.577 12.995 33.94 33.94 0 0 1-7.371 11.022 34.05 34.05 0 0 1-11.042 7.37 34.145 34.145 0 0 1-13.03 2.596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.457 136.517V68.483h-67.972v68.034h67.972Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.457 102.495a34.153 34.153 0 0 1-13.025-2.61 34.058 34.058 0 0 1-11.032-7.38 33.928 33.928 0 0 1-7.358-11.027 33.85 33.85 0 0 1-2.566-12.995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.466 136.517a33.87 33.87 0 0 1 2.566-12.999 33.958 33.958 0 0 1 7.361-11.03 34.065 34.065 0 0 1 11.035-7.382 34.146 34.146 0 0 1 13.029-2.611"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__l)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.514 136.483h-68.028v68.033h68.028v-68.033Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.514 168.213c0 19.873-15.228 35.984-34.033 35.984-18.806 0-33.995-16.111-33.995-35.984M204.426 170.514h-67.882M136.428 136.338l34.101 33.964M204.611 136.338l-34.091 33.954M174.237 156.635a5.298 5.298 0 0 0-.365-7.513 5.37 5.37 0 0 0-7.555.364 5.298 5.298 0 0 0 .366 7.513 5.369 5.369 0 0 0 7.554-.364Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__m)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.446 306.485h-16.331M152.943 306.485H136.85M151.747 308.919a21.403 21.403 0 0 0-2.609 9.919 21.399 21.399 0 0 0 2.302 9.996 21.277 21.277 0 0 0 6.681 7.757 21.156 21.156 0 0 0 9.512 3.724c.728.103 1.46.166 2.195.188h-33.334v-68.006h34.105l-17.586 33.978-1.266 2.444ZM204.506 272.497v67.996h-33.215a19.382 19.382 0 0 0 2.165-.178 21.188 21.188 0 0 0 9.584-3.81 21.31 21.31 0 0 0 6.672-7.895 21.43 21.43 0 0 0 2.19-10.121 21.431 21.431 0 0 0-2.808-9.967l-.049-.109-.989-1.938-17.457-33.978h33.907Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.864 340.245h-3.242v.507h3.242v-.507Z",
    fill: "#fff",
    strokeWidth: 0.5
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__n)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.77 363.354c2.809 0 2.809 5.905 5.608 5.905 2.8 0 2.81-5.905 5.619-5.905 2.809 0 2.799 5.905 5.599 5.905 2.799 0 2.809-5.905 5.618-5.905 2.81 0 2.8 5.905 5.609 5.905s2.809-5.905 5.609-5.905c2.799 0 2.809 5.905 5.618 5.905 2.81 0 2.8-5.905 5.609-5.905s2.809 5.905 5.609 5.905c2.799 0 2.809-5.905 5.618-5.905 2.81 0 2.81 5.905 5.619 5.905 2.809 0 2.809-5.905 5.618-5.905M136.77 353.975c2.809 0 2.809 5.905 5.608 5.905 2.8 0 2.81-5.905 5.619-5.905 2.809 0 2.799 5.905 5.599 5.905 2.799 0 2.809-5.905 5.618-5.905 2.81 0 2.8 5.905 5.609 5.905s2.809-5.905 5.609-5.905c2.799 0 2.809 5.905 5.618 5.905 2.81 0 2.8-5.905 5.609-5.905s2.809 5.905 5.609 5.905c2.799 0 2.809-5.905 5.618-5.905 2.81 0 2.81 5.905 5.619 5.905 2.809 0 2.809-5.905 5.618-5.905M136.77 345.571c2.799 0 2.799 5.905 5.608 5.905 2.81 0 2.81-5.905 5.609-5.905s2.809 5.905 5.609 5.905c2.799 0 2.809-5.905 5.608-5.905 2.8 0 2.81 5.905 5.609 5.905 2.8 0 2.809-5.905 5.619-5.905 2.809 0 2.799 5.905 5.608 5.905 2.81 0 2.81-5.905 5.619-5.905 2.809 0 2.799 5.905 5.609 5.905 2.809 0 2.809-5.905 5.618-5.905 2.81 0 2.81 5.905 5.619 5.905 2.809 0 2.809-5.905 5.618-5.905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.507 340.492h-68.014v68.016h68.014v-68.016Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.498 374.544c0 18.286-15.21 33.108-33.978 33.108s-33.967-14.822-33.967-33.108M136.661 374.505h67.63"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__o)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.507 408.493h-68.014v68.014h68.014v-68.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.291 442.5a33.683 33.683 0 0 1-33.869 33.514 33.675 33.675 0 0 1-23.879-9.739 33.684 33.684 0 0 1-9.99-23.775M136.553 442.461h67.738M136.562 442.5a33.68 33.68 0 0 1 20.953-31.02 33.67 33.67 0 0 1 12.907-2.494 33.675 33.675 0 0 1 23.878 9.739 33.671 33.671 0 0 1 9.991 23.775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.486 442.5a27.934 27.934 0 0 1 47.689-19.753 27.938 27.938 0 0 1 8.182 19.753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.42 442.5a22 22 0 0 1 44.002 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.354 442.5a16.076 16.076 0 0 1 27.299-11.11 16.076 16.076 0 0 1 4.846 11.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.288 442.5a10.14 10.14 0 0 1 10.138-9.827 10.145 10.145 0 0 1 10.138 9.827"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__p)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.493 204.5v67.98h68.015V204.5h-68.015Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.188 204.706c20.218 0 36.593 15.172 36.593 33.902s-16.375 33.902-36.593 33.902M136.818 238.48h36.348M173.747 272.049V204.99M180.26 204.99v67.059M186.763 204.99v67.049M193.275 204.99v67.049M199.778 204.99v67.049"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__q)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.514 136.484h-67.98v68.032h67.98v-68.032Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.495 136c0 19.018-15.198 34.437-33.99 34.437-18.791 0-33.912-15.381-33.912-34.437M136.864 170.476H68M82.024 192.995c2.976 0 5.39-2.403 5.39-5.368 0-2.965-2.414-5.369-5.39-5.369-2.977 0-5.39 2.404-5.39 5.369s2.413 5.368 5.39 5.368ZM102.437 192.995c2.976 0 5.39-2.403 5.39-5.368 0-2.965-2.414-5.369-5.39-5.369-2.977 0-5.39 2.404-5.39 5.369s2.413 5.368 5.39 5.368ZM122.841 192.995c2.977 0 5.39-2.403 5.39-5.368 0-2.965-2.413-5.369-5.39-5.369s-5.39 2.404-5.39 5.369 2.413 5.368 5.39 5.368Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__r)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.484 204.541v67.976h68.021v-67.976h-68.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.484 238.524c4.473.005 8.9.888 13.03 2.599a34.067 34.067 0 0 1 11.039 7.374 33.926 33.926 0 0 1 7.368 11.024 33.865 33.865 0 0 1 2.574 12.995M102.504 204.541a33.83 33.83 0 0 1-2.577 12.995 33.94 33.94 0 0 1-7.371 11.022 34.052 34.052 0 0 1-11.041 7.37 34.144 34.144 0 0 1-13.03 2.596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.457 272.517v-68.034H68.485v68.034h67.972Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.457 238.495a34.148 34.148 0 0 1-13.025-2.61 34.063 34.063 0 0 1-11.032-7.38 33.921 33.921 0 0 1-7.358-11.027 33.846 33.846 0 0 1-2.566-12.995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.466 272.517a33.87 33.87 0 0 1 2.566-12.999 33.958 33.958 0 0 1 7.361-11.03 34.065 34.065 0 0 1 11.035-7.382 34.146 34.146 0 0 1 13.029-2.611"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__s)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.514 272.483H68.486v68.033h68.028v-68.033Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.514 304.213c0 19.873-15.228 35.984-34.033 35.984-18.806 0-33.995-16.111-33.995-35.984M136.426 306.514H68.544M68.428 272.338l34.101 33.964M136.611 272.338l-34.091 33.954M106.237 292.635a5.298 5.298 0 0 0-.365-7.513 5.37 5.37 0 0 0-7.555.364 5.298 5.298 0 0 0 .366 7.513 5.369 5.369 0 0 0 7.554-.364Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__t)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.507.493H68.493v68.014h68.014V.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.507.463A34.005 34.005 0 0 1 78.454 24.51 34.007 34.007 0 0 1 68.494.463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.468 34.421a33.968 33.968 0 0 1-67.936 0M136.675 34.5H68.553"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-vertical_svg__u)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.506 68.493H68.493v68.014h68.013V68.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.602 102.589a33.85 33.85 0 0 1 9.931-23.95 33.927 33.927 0 0 1 23.976-9.92 33.929 33.929 0 0 1 23.977 9.92 33.849 33.849 0 0 1 9.931 23.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.418 102.5a33.88 33.88 0 0 1-10.141 23.595 33.956 33.956 0 0 1-23.792 9.726c-8.9 0-17.445-3.493-23.792-9.726a33.878 33.878 0 0 1-10.14-23.595M68.602 102.5h67.707"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 68)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(68 340)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(68 408)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 136)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 272)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 340)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 408)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 204)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(136)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(136 68)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(136 136)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(136 272)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(136 340)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(136 408)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__p"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(136 204)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__q"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(68 136)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__r"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(68 204)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__s"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(68 272)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__t"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(68)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-vertical_svg__u"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(68 68)",
    d: "M0 0h69v69H0z"
  })))));
};

export { SvgWhiteVertical as ReactComponent };
export default __webpack_public_path__ + "static/white-vertical.c563c616.svg";